import React from 'react'
import TourPortal from '../components/tourPortal/v2/TourPortal'

const Tour = () => {
  return (
    <TourPortal />
  )
}

export default Tour